import { CoolHttp } from '@angular-cool/http';
import { Injectable } from '@angular/core';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import {
  TrackingEventDTO,
  TrackingEventId,
  TrackingEventMinimalDTO,
  TrackingEventRequestParams,
} from '../../../../../common/dto/tracking.dto';

@Injectable()
export class TrackingEventsService {
  constructor(
    private _http: CoolHttp,
  ) {
  }

  public async getTrackingEventsAsync(params: TrackingEventRequestParams): Promise<TrackingEventMinimalDTO[]> {
    return await this._http.getAsync(ServerUrls.TrackingEvents._.Get.getAbsoluteUrlWithQuery({
      [ServerUrls.TrackingEvents._.Get.queryParams.skip]: params.skip?.toString(),
      [ServerUrls.TrackingEvents._.Get.queryParams.limit]: params.limit?.toString(),
      [ServerUrls.TrackingEvents._.Get.queryParams.visitor]: params.visitor?.toString(),
    }));
  }

  public async getTrackingEventByIdAsync(eventId: TrackingEventId): Promise<TrackingEventDTO> {
    return await this._http.getAsync(ServerUrls.TrackingEvents._.ById._.Get.getAbsoluteUrlWithParams({
      [ServerUrls.TrackingEvents._.ById.params.eventId]: eventId,
    }));
  }
}
